export default __webpack_public_path__ + "static/media/Vestments of the Great Impi.34c83e2d.jpg";